export type GeneratorType = {
    dash: string;
    underscope: string;
    slash: string;
    space: string;
    passphrase: string;
    randomString: string;
    wordSeparator: string;
    language: string;
    words: string;
    length: string;
    regenerate: string;
    copy: string;
};
